module.exports = __webpack_public_path__ + "static/EU-kontroll-9ebad9d0c924d497d7593a1338dbc10a.mp4";